import classNames from 'classnames'
import React, { useState } from 'react'

export default function InputUser({name  ,type, icon,classname,setValue,value,eyeIcon,setTypeInput}) {
  const [isChecked,setIsChecked] = useState(true)
  const changeTypeInput = (e) =>{
    e.preventDefault()
    setIsChecked((prev) => !prev)
    setTypeInput(() =>{
      return isChecked ? "text" : "password"
    })

  }
  
  return (
    
        <div className={classNames(" flex flex-row items-center  bg-opacity-20 bg-white  rounded-full w-full  mx-auto  h-14 pl-5 md:pl-8 leading-[56px] ",classname)}>
            <i className={icon} ></i>
            <input type= {type} value={value} onChange={(e)=> setValue(e.target.value)} placeholder ={name}  className={classNames(" text-[px] bg-transparent placeholder-[#FFFFFF] outline-none active:border-0 focus:border-none w-[80%] sm:w-[83%]  md:w-[85%] lg:w-[88%]",{
              "text-[15px]": type == "text",
              "text-[9px] placeholder:text-[15px]": type == "password"
            })}/>
            {eyeIcon&&value && <button onClick={changeTypeInput}><i className= {classNames({
              "fa-solid fa-eye-slash": isChecked,
              "fa-solid fa-eye":!isChecked
            })}></i></button>}
        </div>
  )
}
